import { useCallback, useContext } from 'react'
import { WallboxLabelContext } from '../providers/WallboxLabelContext'

interface UseWallboxLabel {
  getWallboxLabel: (params: { wallboxId: string }) => string
}

/**
 * Light wrapper around useContext to reuse previously calculated map of wallbox id to wallbox label
 * for improved performance across different pages that are rendered from scratch.
 */
export const useWallboxLabel = (): UseWallboxLabel => {
  const { wallboxLabelMap } = useContext(WallboxLabelContext)

  const getWallboxLabel = useCallback(
    ({ wallboxId }: { wallboxId: string }) => {
      return wallboxLabelMap[wallboxId]
    },
    [wallboxLabelMap]
  )

  return { getWallboxLabel }
}
